import { DetailPage } from '@/pages/events';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_private/events/$eventUuid/detail')({
  component: DetailPage,
});
